import React from "react";

export type SectionViewMode = "graph" | "table";

interface SectionToggleProps {
  title: string;
  subtitle?: string;
  mode: SectionViewMode;
  onChange: (mode: SectionViewMode) => void;
  actions?: React.ReactNode;
}

export const SectionToggle: React.FC<SectionToggleProps> = ({
  title,
  subtitle,
  mode,
  onChange,
  actions,
}) => {
  return (
    <div className="mb-0 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        {subtitle && <p className="mt-0.5 text-xs text-gray-500">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">
        {actions}
        <div className="inline-flex border border-cardborder bg-gray-100 p-0.5">
          <button
            type="button"
            onClick={() => onChange("graph")}
            className={`px-3 py-1.5 text-xs font-medium transition-colors ${
              mode === "graph"
                ? "bg-white text-gray-900 shadow-sm ring-1 ring-gray-200"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Graph
          </button>
          <button
            type="button"
            onClick={() => onChange("table")}
            className={`px-3 py-1.5 text-xs font-medium transition-colors ${
              mode === "table"
                ? "bg-white text-gray-900 shadow-sm ring-1 ring-gray-200"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            Table
          </button>
        </div>
      </div>
    </div>
  );
};

